import React from 'react';
import Intro from 'features/project-cases/Intro';
import ProjectConcept from 'features/project-cases/ProjectConcept';
import Container from 'components/UI/Container';
import ContactUs from 'features/common/ContactUs';
import SEO from 'components/SEO';

import data from './data.json';

export default function DigitalBankingApp() {
  return (
    <>
      <Intro {...data.intro} />
      <ProjectConcept {...data.concept} setActive={() => {}} />
      <Container padding="Without" theme="fullWidth">
        <ContactUs {...data.getConsultation} />
      </Container>
    </>
  );
}

export const Head = ({ location }) => <SEO {...data.head} {...location} />;
